import {INFO_DISMISS} from "../types";

const infoDismiss= () => {
  return ({type: INFO_DISMISS, payload: {info: {message: null, type: null}}});
};
export default infoDismiss;